const config = {
  apiKey: "AIzaSyBoUJodKbm4FTwK5rGySiQGpmGED3mpqqo",
  authDomain: "territories-1d6eb.firebaseapp.com",
  databaseURL: "https://territories-1d6eb.firebaseio.com",
  projectId: "territories-1d6eb",
  storageBucket: "territories-1d6eb.appspot.com",
  messagingSenderId: "652111387482"
};

export default config;
